/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { cloneChildComponents } from '../../../utils/helpers'

// Handles the view of GWS_DISABLE_USER_MFA
function DisableMfa(props) {
  const { children, ...rest } = props
  const { setCompletedActions, selectedEmployees, setActionData } = rest

  const DISABLE_SUCCESS_ACTION_ID = 'ENGAGE.DISABLE_MFA_SUCCESS'

  const [employeesWithMfaEnabled, setEmployeesWithMfaEnabled] = useState([])

  // Handle setting the employees to disable mfa for
  useEffect(() => {
    if (selectedEmployees?.length) {
      setEmployeesWithMfaEnabled(selectedEmployees.filter((employee) => employee.mfaEnabled))
    }
  }, [selectedEmployees])

  // Handles formatting the task parameters which will be stored in actionData, and passed down to the GenericModalFooter to fire off the task (using actionData for task parameters)
  useEffect(() => {
    const employees = []
    // eslint-disable-next-line no-restricted-syntax
    for (const employee of employeesWithMfaEnabled) {
      employees.push({
        employeeEmail: employee?.email ? employee.email : undefined,
        employeeIdentifier: employee?.employeeIdentifier ? employee.employeeIdentifier : undefined,
      })
    }

    // Update the actionData with required information
    const newActionData = {}

    // Add task parameter data to actionData
    newActionData.employeesWithMfaEnabled = employees

    // Add success body data to actionData
    const employeeNamesGettingMfaDisabled = []
    // eslint-disable-next-line no-restricted-syntax
    for (const employeeGettingMfaDisabled of employeesWithMfaEnabled) {
      employeeNamesGettingMfaDisabled.push({
        employeeFullName: `${employeeGettingMfaDisabled.firstName} ${employeeGettingMfaDisabled.lastName}`,
      })
    }
    newActionData.employeesGettingMfaDisabled = employeeNamesGettingMfaDisabled

    setActionData(newActionData)
  }, [employeesWithMfaEnabled]) // eslint-disable-line react-hooks/exhaustive-deps

  // Handles setting the completed action on initial render. Doing here because there is only 1 possible action in this flow
  useEffect(() => {
    setCompletedActions((alreadyCompletedActions) => [...alreadyCompletedActions, DISABLE_SUCCESS_ACTION_ID])
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PerfectScrollbar options={{ wheelSpeed: 2, wheelPropagation: false }} className="paginator-margin-bottom">
      <Form>
        <Modal.Body>
          <Row>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <p className="font-bolder font-lg mb-3">
                {selectedEmployees.length === 1 ? (
                  <FormattedMessage id="ENGAGE.DISABLE_MFA_FOR_SELECTED_EMPLOYEE" />
                ) : (
                  <FormattedMessage id="ENGAGE.DISABLE_MFA_FOR_SELECTED_EMPLOYEES" />
                )}
              </p>
            </div>
          </Row>
          <Row>
            <ul style={{ marginLeft: '1rem' }}>
              {employeesWithMfaEnabled.map((employee, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index}>
                  <span>{`${employee.firstName} ${employee.lastName}`}</span>
                </li>
              ))}
            </ul>
          </Row>
        </Modal.Body>

        {/* Footer Child */}
        {cloneChildComponents({ ...rest }, children)}
      </Form>
    </PerfectScrollbar>
  )
}

export default DisableMfa
